import styled from "styled-components";
import {formats} from "common/graphs/NVStackedAreaChart";

export const TileContainer = styled.div`
  position: relative;
  min-height: 6cm;
  display: flex;
  flex-direction: column;
  & > h4 {
    text-align: center;
    margin: 20px 0 0 0;
  }
  .graph {
    flex: 1 1 100%;
    margin: 0;
    .nv-y.nv-axis .nv-axisMaxMin {
      display: none;
    }

    .legends {
      ul {
        margin-top: 5px;
        margin-bottom: 0;
      }
    }

    @media screen and (min-width: 1270px) {
      .legends {
        position: absolute;
        top: -15px;
        right: 0;

        ul {
          margin-top: 0;
          margin-bottom: 0;
        }
      }
    }
  }
  &.spread {
    justify-content: space-between;
    padding: 1em;
    align-content: flex-start;
  }
  &.can-compress {
    min-height: 0;
  }
  .input-group {
    max-width: 20ch;
  }
  &.title-and-graph .title {
    font-family: "AllianceNo2-SemiBold";
    font-weight: 100;
    text-align: left !important;
    color: var(--subtitle-color);
    font-size: var(--chart-title-font-size, 18px);
    text-transform: var(--chart-title-text-transform, capitalize);
    margin: 0;
  }
`;

export function getInRangeItems(items, range, fields, sampleSize) {
  if (items.length === 0 || fields.length === 0) {
    return [];
  }

  const { from, to } = range;
  let inrangeItems = [];
  let maxItems;
  for (let i = 0; i < items.length; i += 1) {
    const { time } = items[i];
    if (from <= time && time <= to) {
      if (!maxItems) {
        maxItems = { ...items[i] };
      }
      if (i % sampleSize === 0) {
        inrangeItems.push(maxItems);
        maxItems = { ...items[i] };
      } else {
        const newMax = fields.reduce((acc, { name }) => {
          if (items[i][name] > acc[name]) {
            acc[name] = items[i][name];
          }
          return acc;
        }, maxItems);
        maxItems = newMax;
      }
    }
  }

  if (inrangeItems.length === 0) {
    return [];
  }

  if (
    inrangeItems[inrangeItems.length - 1]?.time &&
    items[items.length - 1]?.time &&
    inrangeItems[inrangeItems.length - 1].time !== items[items.length - 1]?.time
  ) {
    const { time } = items[items.length - 1];
    if (from <= time && time <= to) {
      inrangeItems.push(items[items.length - 1]);
    }
  }
  
  return inrangeItems;
}

export const timeCoeffMap = {
  24: 1000 * 60 * 5,
  168: 1000 * 60 * 10,
  720: 1000 * 60 * 60,
  744: 1000 * 60 * 60,
  2160: 1000 * 60 * 60,
  2232: 1000 * 60 * 60,
};